// @ts-nocheck
export const themeType = {
  Dark: 'dark',
  Light: 'light',
};
